module.exports = __webpack_public_path__ + "static/media/Alert-home-icon.ad593cdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/Alert-home-icon.svg
// module id = 625
// module chunks = 0